exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1S2eD84y_5QJ60cHuLw0RH{height:55px}.JW6biuVNNJGdDTU7t1DWd{height:93px}", ""]);

// exports
exports.locals = {
	"messageAdStaticContainerReadingPaneOff": "_1S2eD84y_5QJ60cHuLw0RH",
	"messageAdStaticContainerReadingPaneOn": "JW6biuVNNJGdDTU7t1DWd"
};